import { render, staticRenderFns } from "./CapacityHeatmap.vue?vue&type=template&id=37240516&scoped=true"
import script from "./CapacityHeatmap.vue?vue&type=script&lang=js"
export * from "./CapacityHeatmap.vue?vue&type=script&lang=js"
import style0 from "./CapacityHeatmap.vue?vue&type=style&index=0&id=37240516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37240516",
  null
  
)

export default component.exports